import { createBrowserHistory } from "history";

// Função para pegar o href da tag <base> dinamicamente
const getBasename = () => {
  const baseTag = document.getElementsByTagName('base')[0];
  if (baseTag && baseTag.getAttribute('href')) {
    // Remove o domínio se houver, deixando apenas o path
    return baseTag.getAttribute('href')?.replace(window.location.origin, '');
  }
  return '/';
};

export default createBrowserHistory({
  basename: getBasename()
});
